import React from 'react';

import ProcessingIndicator from './ProcessingIndicator';

import './ActionButton.scss';

class ActionButton extends React.Component {
  render() {
    const {
      label = '',
      id = '',
      classNames = [],
      inProgressState = false,
      onClick,
      disabled = false
    } = this.props;

    // * == Classes from WordPress Admin theme
    classNames.push(
      'button', // *
      'button-primary', // *
      'parkchirp--action-button'
    );
    if (inProgressState) classNames.push('parkchirp--action-button--in-progress');

    return (
      <button type="button"
        id={id}
        className={classNames.join(' ')}
        onClick={onClick}
        disabled={disabled || inProgressState}>
        <span className="parkchirp--action-button--label">{label}</span>
        <span className="parkchirp--action-button--in-progress-indicator">
          <ProcessingIndicator style={disabled || inProgressState ? 'dark' : 'light'} />
        </span>
      </button>
    );
  }
}

export default ActionButton;
